import { Pipe, PipeTransform } from '@angular/core';
import { format, parse, parseISO } from 'date-fns';

@Pipe({
  name: 'dateFormat',
})
export class DateFormatPipe implements PipeTransform {
  transform(value: string, dateFormat: string = 'dd/MM/yyyy'): string {
    if (!value) return '-';

    let date: Date | null = null;
    const processedValue = value.trim();

    const ddMmYyyyRegex = /^\d{2}-\d{2}-\d{4}$/;
    const yyyyMmDdRegex = /^\d{4}-\d{2}-\d{2}$/;

    if (yyyyMmDdRegex.test(processedValue)) {
      date = parse(processedValue, 'yyyy-MM-dd', new Date());
    } else if (ddMmYyyyRegex.test(processedValue)) {
      date = parse(processedValue, 'dd-MM-yyyy', new Date());
    } else if (processedValue.includes('T')) {
      date = parseISO(processedValue);
    } else {
      date = new Date(processedValue);
    }

    if (date === null || isNaN(date.getTime())) {
      return '-';
    }

    return format(date, dateFormat);
  }
}
